import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { Valuta } from './valuta';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-valuta-modal-update',
  templateUrl: './valuta-modal-update.component.html'
})
export class ValutaModalUpdateComponent extends BaseModalUpdateComponent<Valuta> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Valuta>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
